import { memo, useCallback, useEffect, useRef, useState } from 'react';

import { IconButton } from 'basic-components';
import { Clear } from 'basic-components/icons';

import properties from 'resources/constants/properties.json';

import { When } from 'react-if';

import classNames from 'classnames';
import './EndOfService.scss';

const EndOfService = ({ tokenExist }) => {
  const timeout = useRef(),
        [displayExpiryWarn, setDisplayExpiryWarn] = useState(true),
        [animationExpiryWarn, setAnimationExpiryWarn] = useState(false),
        openEmail = useCallback(() => {
          window.open(`mailto:${properties.end_of_service_email}`)
        }, []),
        hideExpiryWarn = useCallback(() => {
          setAnimationExpiryWarn(true)
          timeout.current = setTimeout(() => setDisplayExpiryWarn(false), 501)
        }, [setDisplayExpiryWarn, setAnimationExpiryWarn])

  useEffect(() => () => {
    clearTimeout(timeout.current)
  }, [])
  return (
    <When condition={displayExpiryWarn}>
      {() => (
        <div className={classNames("end-of-service", { "end-of-service--is-long": !tokenExist }, { "end-of-service--hide": animationExpiryWarn })}>
          <div className="end-of-service__text">
            <p>
              {`Warning: Your access to this service will end on ${properties.end_of_service_date}. Please contact `}
            </p>
            <div
                className="end-of-service__text__link"
                onClick={openEmail}
            >
              {properties.end_of_service_email}
            </div>
            <p>
              with any questions.
            </p>
          </div>
          <IconButton
              className="end-of-service__clear"
              onClick={hideExpiryWarn}
          >
            <Clear
                height={16}
                width={16}
            />
          </IconButton>
        </div>
      )}
    </When>
  )
}

export default memo(EndOfService);
